import type { StreamEventOut } from '@porotutu/api/features/shared/notifications/model'
import { origin, type StreamOpener, unwrap } from '@porotutu/react/api'
import { queryOptions } from '@tanstack/react-query'
import { crm } from './client'
import { NOTIFICATIONS } from './keys'

export type NotificationPage = Awaited<ReturnType<typeof readInbox>>

export type Notification = NotificationPage['data'][number]

export type NotificationFrame = StreamEventOut

const readInbox = async () => unwrap(await crm.notifications.get({ query: { limit: 10 } }))

export const notificationsQuery = queryOptions({
  queryKey: NOTIFICATIONS,
  queryFn: readInbox,
})

export const markAllRead = async () => unwrap(await crm.notifications.read.post({}))

export const openNotificationStream: StreamOpener = (signal) =>
  fetch(`${origin()}/api/v1/crm/notifications/stream`, {
    headers: { accept: 'text/event-stream' },
    credentials: 'include',
    signal,
  })
